import React from 'react';

function Privacy() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Política de Privacidad</h1>
      
      <div className="prose max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Información que Recopilamos</h2>
          <p className="mb-4">
            En nuestro directorio médico, recopilamos y mostramos información pública sobre profesionales de la salud, incluyendo:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Nombre y título profesional</li>
            <li>Especialidad médica</li>
            <li>Dirección del consultorio</li>
            <li>Información de contacto profesional</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Uso de la Información</h2>
          <p className="mb-4">
            La información recopilada se utiliza exclusivamente para:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Facilitar la búsqueda de profesionales de la salud</li>
            <li>Proporcionar información relevante a los usuarios</li>
            <li>Mejorar nuestros servicios</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Protección de Datos</h2>
          <p className="mb-4">
            Nos comprometemos a proteger la información personal y profesional mostrada en nuestro directorio.
            Implementamos medidas de seguridad para prevenir el acceso no autorizado o el uso indebido de la información.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Derechos de los Profesionales</h2>
          <p className="mb-4">
            Los profesionales de la salud listados en nuestro directorio tienen derecho a:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Solicitar la actualización de su información</li>
            <li>Solicitar la eliminación de su información</li>
            <li>Acceder a los datos que mantenemos sobre ellos</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Contacto</h2>
          <p className="mb-4">
            Para cualquier consulta relacionada con nuestra política de privacidad o para ejercer sus derechos,
            por favor contáctenos a través de nuestro formulario de contacto.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Privacy; 